import {
  isValidCnpj as isValidCnpjFromLib,
  parseCnpj,
} from '@brazilian-utils/brazilian-utils';

export function isValidCnpj(raw: string): boolean {
  const cnpj = parseCnpj(raw, { version: 2 });

  if (cnpj.length !== 14 || /^(.)\1{13}$/.test(cnpj)) {
    return false;
  }

  return isValidCnpjFromLib(cnpj, { version: 2 });
}
